var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 mt-3"},[_c('b-container',[_c('h1',{staticClass:"text-primary font-weight-bold text-center mb-5"},[_vm._v(_vm._s(_vm.$t('colony_edit.title')))]),_c('colony-form',{attrs:{"id":_vm.id,"apiary":_vm.apiary}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }